// Generated types for DanglingPortResolutionTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { LLMTaskReadAPI, LLMTaskWriteAPI } from '../../llm_task/types/llmtask';
import { LLMTaskReadAPISchemaObject, LLMTaskWriteAPISchemaObject } from '../../llm_task/types/llmtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface DanglingPortResolutionTaskReadAPI extends LLMTaskReadAPI {
}

export interface DanglingPortResolutionTaskWriteAPI extends LLMTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const DanglingPortResolutionTaskReadAPISchema: z.ZodType<DanglingPortResolutionTaskReadAPI> = LLMTaskReadAPISchemaObject.extend({}).passthrough();

export const DanglingPortResolutionTaskWriteAPISchema: z.ZodType<DanglingPortResolutionTaskWriteAPI> = LLMTaskWriteAPISchemaObject.extend({}).passthrough();
